module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-plus-fill-860d816b.svg";